import { Component, OnInit, OnDestroy } from '@angular/core';

import { ModalService } from '../../../shared/modules/modal';

import {
  AdjustmentSummary,
  AdjustmentEffectivenessErrorResponse,
  AdjustmentEffectivenessModalPayload,
  AdjustmentEffectivenessPayload
} from '../../../shared/models';

import { AdjustmentEffectivenessService } from '../../../shared/services/adjustment-effectivenes.service';
import { NotificationService } from '../../../shared/services';

import {
  ClosableModalWithErrorResponseModel } from '../../../shared/components/base/closable-modal-with-error-response-model';

@Component({
  selector: 'effectiveness-modal',
  templateUrl: './effectiveness-modal.component.html',
})
export class EffectivenessModalComponent
  extends ClosableModalWithErrorResponseModel<AdjustmentEffectivenessErrorResponse>
  implements OnInit, OnDestroy {

  data: AdjustmentEffectivenessModalPayload;
  adjustmentSummary: AdjustmentSummary = new AdjustmentSummary();

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _adjustmentEffectivenessService: AdjustmentEffectivenessService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new AdjustmentEffectivenessErrorResponse();
  }

  ngOnInit(): void {
    this.adjustmentSummary = Object.assign({}, this.data.summary.adjustmentSummaries[0]);

    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.responseErrors = [];

    // we send an empty string in order to delete an already saved value
    // sending null would not delete it
    const payload: AdjustmentEffectivenessPayload = {
      adjustmentEffectiveness: this.adjustmentSummary.adjustmentEffectiveness.id,
    } as AdjustmentEffectivenessPayload;
    const summaryId: number = this.data.summary.adjustmentSummaries[0].adjustmentSummaryId;

    this._adjustmentEffectivenessService.edit(summaryId, payload).subscribe(() => {
      this.success();
      this.close();
    });
  }

  close(): void {
    this.closeAllModals();
  }

  checkForValidationError(code: string): boolean {
    return !!this.validationErrors[code];
  }
}
